import { css } from "@emotion/css";
import React, { useMemo } from "react";
import { DriverReportContent } from "@/common/DriverReportsPage/DriverReportContent";
import { useQueryParam } from "@/customHooks/useQueryParam";
import { NoDriverReport } from "@/common/DriverReportsPage/NoDriverReport";
import { useDriverReport } from "@/common/DriverReportsPage/useDriverReport";
import { LoadingSpinnerWithBackdrop } from "@/common/LoadingSpinnerWithBackdrop";
import { pdf } from "@react-pdf/renderer";
import { PdfDriverReportDocument } from "@/common/DriverReportsPage/PdfDriverReportDocument";
import format from "date-fns/format";
import { useFirebaseStorage } from "@/customHooks/useFirebaseStorage";
import { useGetStorageDownloadUrl } from "@/customHooks/useGetStorageDownloadUrl";
import { Button } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import { useCompanyPersistStore } from "@/stores/useCompanyPersistStore";
import { getBlob } from "firebase/storage";

const FILE_NAME = "DriverReport.tsx";

const styles = {
    main: css({
        flex: 1
    }),
    loadingWrapper: css({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        minHeight: 200
    })
};

export function DriverReport() {
    const { value: selectedReportId } = useQueryParam("report");
    const { driverReportData, deliveryNotes, isLoading } = useDriverReport();
    const members = useCompanyPersistStore(state => state.members);

    const driver = useMemo(() => {
        return members.find(m => m.user_id === driverReportData.driver);
    }, [members, driverReportData]);

    const pdfName = useMemo(() => {
        return `${format(driverReportData.day || 0, "yyyy_MM_dd")} ${driver?.displayName || ""} Tagesbericht`
    }, [driverReportData, driver]);

    const { storageRefs } = useFirebaseStorage();
    const { data: signatureImageUrl, status: signatureImageStatus } = useGetStorageDownloadUrl(
        storageRefs.drivingJobSignature(driverReportData.signature_image_id)
    );

    async function abc() {
        const a = await getBlob(storageRefs.drivingJobSignature(driverReportData.signature_image_id));
        return a;
    }

    const isReportIdValid = (
        !!selectedReportId &&
        !isLoading &&
        !!driverReportData?.doc_id
    );

    async function handleCreatePDF(): Promise<Blob> {
        const getSignatureImage = async (): Promise<string> => {
            try {
                const signatureBlob = await getBlob(storageRefs.drivingJobSignature(driverReportData.signature_image_id));
                return URL.createObjectURL(signatureBlob);
            } catch (err) {
                console.error("getSignatureImage():", err);
                return "";
            }
        };

        // Create a PDF document
        const doc = <PdfDriverReportDocument
            driverReportData={driverReportData}
            data={{
                driver: driver?.displayName || "",
                pdfName,
                drivingJobs: deliveryNotes || [],
                signatureImageUrl: await getSignatureImage(),
            }}
        />;

        const asPdf = pdf(); // Creating an empty PDF object
        asPdf.updateContainer(doc);
        return await asPdf.toBlob();
    }

    async function handleDownloadPDF() {
        const blob = await handleCreatePDF();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${pdfName}.pdf`;
        link.click();
        link.remove();
    }

    async function handlePrintPDF() {
        const blob = await handleCreatePDF();
        const blobURL = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobURL;
        document.body.appendChild(iframe);

        iframe.onload = () => {
            iframe.contentWindow?.print();
        };
    }

    return <div className={styles.main}>
        {isLoading ?
            <LoadingSpinnerWithBackdrop disableTransparentBackground/>
            :
            isReportIdValid ? <>
                    <DriverReportContent
                        driverReportData={driverReportData}
                        deliveryNotes={deliveryNotes}
                        signatureImageUrl={signatureImageUrl}
                        signatureImageStatus={signatureImageStatus}
                    />
                    <Button
                        sx={{ mt: "20px", mr: 1 }}
                        size="small"
                        onClick={handlePrintPDF}
                        startIcon={<PrintIcon/>}
                    >
                        Bericht drucken
                    </Button>
                    <Button
                        sx={{ mt: "20px" }}
                        size="small"
                        onClick={handleDownloadPDF}
                        startIcon={<DownloadIcon/>}
                    >
                        Bericht herunterladen
                    </Button>
                </> :
                <NoDriverReport selectedReportId={selectedReportId}/>
        }

        {/*<PDFViewer style={{ width: "100%", height: "1000px", paddingTop: 20, border: "none" }}>*/}
        {/*    <PdfDriverReportDocument data={{*/}
        {/*        driver: "Max Mustermann",*/}
        {/*        date: new Date(),*/}
        {/*        pdfName,*/}
        {/*        drivingJobs: deliveryNotes || [],*/}
        {/*        signatureImageUrl: signatureImageUrl*/}
        {/*    }}/>*/}
        {/*</PDFViewer>*/}
    </div>;
}
